
import React, { useState } from "react";
import "../styles.css";
import ReactModal from "react-modal";
import { BoxModal } from "../../../../components/boxModal";
import { NavLink } from "react-router-dom";
import { FiShare2 } from 'react-icons/fi';
import { useNavigate } from "react-router-dom";
import { PostPaymentWarning } from "./PaymentWarnings";


export const VoucherModal = ({ boleto, setModalVoucher, modalVoucher, user, isVoucherButtonDisabled }) => {

    const navigate = useNavigate();

    const onCloseModal = () => {
        setModalVoucher(false);
        navigate("/pagina-pagar-boleto");
    };

    const formatCurrency = (value) => {
        return Number(value || 0)
            .toFixed(2)
            .toString()
            .replace('.', ',');
    };

    return (
        <ReactModal
            isOpen={modalVoucher}
            className="change-modal"
            overlayClassName="overlay-pix-modal"
            shouldCloseOnOverlayClick={false}
        >
            <BoxModal
                icon={user.isMainAccess ? "circleCheck" : "pendingIcon"}
                title={user.isMainAccess ? "Pagamento de Boleto realizado com sucesso" : "Pagamento de Boleto aguardando aprovação"}
                close={() => onCloseModal()}
                maxWidth={700}
            >
                <div className="step3-content">
                    <div className="step3-content-infos">
                        <div className="step3-content-info">
                            <div className="info-item">
                                Valor
                                <span>R$: {formatCurrency(boleto.updatedValue)}</span>
                            </div>

                            <div className="info-item">
                                Código de Boleto
                                <span>{boleto.barcode}</span>
                            </div>
                        </div>

                        <div className="step3-content-info">
                            <div className="info-item">
                                Instituição de Destino
                                <span>
                                    {boleto.bankCode} - {boleto.bankName}
                                </span>
                            </div>
                        </div>
                    </div>

                    <PostPaymentWarning />

                    {
                        user.isMainAccess &&
                        <div className="step-buttons step3-buttons">
                            <NavLink
                                target="_blank"
                                to={isVoucherButtonDisabled ? "#" : "/comprovante"}
                                className={`step-button ${isVoucherButtonDisabled ? "disabled-link" : ""}`}
                                onClick={(e) => isVoucherButtonDisabled && e.preventDefault()}
                            >
                                Compartilhar comprovante
                                <FiShare2 size={16} />
                            </NavLink>
                        </div>
                    }
                </div>
            </BoxModal>
        </ReactModal>
    );
};
